var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-11/12 border border-primary rounded bg-white"},[_c('div',{staticClass:"bg-gradient-to-b from-button-primary-top to-button-primary-bottom h-2 origin-left animate-progress"})])
}]

export { render, staticRenderFns }